import { withTranslation } from 'react-i18next';

import ReactSelect from '../../../../components/ReactSelect';
import { GRID_SELECT } from '../../GscTools/selectStyles';
import { SEGMENTS, segmentLabel } from '../segments';

/**
 * This report's own scope controls, laid out in the shared control grid beside the property and
 * the dates: which dimension the traffic is cut by, and an optional page prefix to read it inside.
 *
 * Both change what is asked of Search Console, so both sit behind the same Apply as the rest of
 * the scope rather than acting as one is typed. The prefix is deliberately ad hoc — a rule for
 * this report, kept in its address and nowhere else; named, reusable groupings are a different
 * feature with a different lifetime.
 */
function ExtraControls({ t, draft, onChange }) {
    const segmentOptions = SEGMENTS.map((value) => ({
        value,
        label: segmentLabel(t, value),
    }));

    return (
        <>
            <div className="gsc-tool-field">
                <label>{t('tools.audience_appearance.controls.segment')}</label>
                <ReactSelect
                    options={segmentOptions}
                    value={segmentOptions.find((item) => item.value === draft.segment)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ segment: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.audience_appearance.controls.segment_note')}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label htmlFor="aa-page-prefix">
                    {t('tools.audience_appearance.controls.page_prefix')}
                </label>
                <input
                    id="aa-page-prefix"
                    type="text"
                    className="form-control"
                    value={draft.pagePrefix}
                    placeholder={t('tools.audience_appearance.controls.page_prefix_placeholder')}
                    onChange={(event) => onChange({ pagePrefix: event.target.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.audience_appearance.controls.page_prefix_note')}
                </span>
            </div>
        </>
    );
}

export default withTranslation()(ExtraControls);
